import type { Sku } from "../types";

/**
 * OpenRouter, one SKU per endpoint of each model Pax calls, at the prices OpenRouter lists, and an
 * `auto` SKU per tier priced at the cost OpenRouter reports. Written by
 * `bun run prices:openrouter`.
 */
export const openrouterSkus: readonly Sku[] = [
  {
    id: "openrouter:anthropic/claude-opus-5.5:auto:default",
    billedBy: "openrouter",
    model: "anthropic/claude-opus-5.5",
    endpoint: "auto",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "reportedInputCost",
        meter: "reportedInputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      {
        id: "reportedOutputCost",
        meter: "reportedOutputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      { id: "reportedCost", meter: "reportedCost", unit: "USD", currency: "USD", amount: 1 },
    ],
  },
  {
    id: "openrouter:anthropic/claude-opus-5.5:auto:priority",
    billedBy: "openrouter",
    model: "anthropic/claude-opus-5.5",
    endpoint: "auto",
    tier: "priority",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "reportedInputCost",
        meter: "reportedInputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      {
        id: "reportedOutputCost",
        meter: "reportedOutputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      { id: "reportedCost", meter: "reportedCost", unit: "USD", currency: "USD", amount: 1 },
    ],
  },
  {
    id: "openrouter:anthropic/claude-opus-5.5:amazon-bedrock:default",
    billedBy: "openrouter",
    model: "anthropic/claude-opus-5.5",
    endpoint: "amazon-bedrock",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 4,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.2,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 20 },
      { id: "cacheWrite5m", meter: "cacheWrite5m", unit: "1M tokens", currency: "USD", amount: 5 },
      { id: "cacheWrite1h", meter: "cacheWrite1h", unit: "1M tokens", currency: "USD", amount: 8 },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:anthropic/claude-opus-5.5:amazon-bedrock/eu-west-1:default",
    billedBy: "openrouter",
    model: "anthropic/claude-opus-5.5",
    endpoint: "amazon-bedrock/eu-west-1",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 4.4,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.22,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 22 },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 5.5,
      },
      {
        id: "cacheWrite1h",
        meter: "cacheWrite1h",
        unit: "1M tokens",
        currency: "USD",
        amount: 8.8,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:anthropic/claude-opus-5.5:amazon-bedrock/us-east-1:default",
    billedBy: "openrouter",
    model: "anthropic/claude-opus-5.5",
    endpoint: "amazon-bedrock/us-east-1",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 4.4,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.22,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 22 },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 5.5,
      },
      {
        id: "cacheWrite1h",
        meter: "cacheWrite1h",
        unit: "1M tokens",
        currency: "USD",
        amount: 8.8,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:anthropic/claude-opus-5.5:anthropic:default",
    billedBy: "openrouter",
    model: "anthropic/claude-opus-5.5",
    endpoint: "anthropic",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 4,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.2,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 20 },
      { id: "cacheWrite5m", meter: "cacheWrite5m", unit: "1M tokens", currency: "USD", amount: 5 },
      { id: "cacheWrite1h", meter: "cacheWrite1h", unit: "1M tokens", currency: "USD", amount: 8 },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:anthropic/claude-opus-5.5:anthropic/fast:priority",
    billedBy: "openrouter",
    model: "anthropic/claude-opus-5.5",
    endpoint: "anthropic/fast",
    tier: "priority",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 8,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.4,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 40 },
      { id: "cacheWrite5m", meter: "cacheWrite5m", unit: "1M tokens", currency: "USD", amount: 10 },
      { id: "cacheWrite1h", meter: "cacheWrite1h", unit: "1M tokens", currency: "USD", amount: 16 },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:anthropic/claude-opus-5.5:azure/global:default",
    billedBy: "openrouter",
    model: "anthropic/claude-opus-5.5",
    endpoint: "azure/global",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 4,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.2,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 20 },
      { id: "cacheWrite5m", meter: "cacheWrite5m", unit: "1M tokens", currency: "USD", amount: 5 },
      { id: "cacheWrite1h", meter: "cacheWrite1h", unit: "1M tokens", currency: "USD", amount: 8 },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:anthropic/claude-opus-5.5:azure/us:default",
    billedBy: "openrouter",
    model: "anthropic/claude-opus-5.5",
    endpoint: "azure/us",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 4.4,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.22,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 22 },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 5.5,
      },
      {
        id: "cacheWrite1h",
        meter: "cacheWrite1h",
        unit: "1M tokens",
        currency: "USD",
        amount: 8.8,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:anthropic/claude-opus-5.5:claude-on-aws:default",
    billedBy: "openrouter",
    model: "anthropic/claude-opus-5.5",
    endpoint: "claude-on-aws",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 4,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.2,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 20 },
      { id: "cacheWrite5m", meter: "cacheWrite5m", unit: "1M tokens", currency: "USD", amount: 5 },
      { id: "cacheWrite1h", meter: "cacheWrite1h", unit: "1M tokens", currency: "USD", amount: 8 },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:anthropic/claude-opus-5.5:google-vertex/europe:default",
    billedBy: "openrouter",
    model: "anthropic/claude-opus-5.5",
    endpoint: "google-vertex/europe",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 4.4,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.22,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 22 },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 5.5,
      },
      {
        id: "cacheWrite1h",
        meter: "cacheWrite1h",
        unit: "1M tokens",
        currency: "USD",
        amount: 8.8,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:anthropic/claude-opus-5.5:google-vertex/global:default",
    billedBy: "openrouter",
    model: "anthropic/claude-opus-5.5",
    endpoint: "google-vertex/global",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 4,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.2,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 20 },
      { id: "cacheWrite5m", meter: "cacheWrite5m", unit: "1M tokens", currency: "USD", amount: 5 },
      { id: "cacheWrite1h", meter: "cacheWrite1h", unit: "1M tokens", currency: "USD", amount: 8 },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:anthropic/claude-opus-5.5:google-vertex/us:default",
    billedBy: "openrouter",
    model: "anthropic/claude-opus-5.5",
    endpoint: "google-vertex/us",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 4.4,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.22,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 22 },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 5.5,
      },
      {
        id: "cacheWrite1h",
        meter: "cacheWrite1h",
        unit: "1M tokens",
        currency: "USD",
        amount: 8.8,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:google/gemini-3.8-flash:auto:default",
    billedBy: "openrouter",
    model: "google/gemini-3.8-flash",
    endpoint: "auto",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 65_536,
    prices: [
      {
        id: "reportedInputCost",
        meter: "reportedInputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      {
        id: "reportedOutputCost",
        meter: "reportedOutputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      { id: "reportedCost", meter: "reportedCost", unit: "USD", currency: "USD", amount: 1 },
    ],
  },
  {
    id: "openrouter:google/gemini-3.8-flash:auto:flex",
    billedBy: "openrouter",
    model: "google/gemini-3.8-flash",
    endpoint: "auto",
    tier: "flex",
    promptTokensCount: "allInput",
    maxOutputTokens: 65_536,
    prices: [
      {
        id: "reportedInputCost",
        meter: "reportedInputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      {
        id: "reportedOutputCost",
        meter: "reportedOutputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      { id: "reportedCost", meter: "reportedCost", unit: "USD", currency: "USD", amount: 1 },
    ],
  },
  {
    id: "openrouter:google/gemini-3.8-flash:auto:priority",
    billedBy: "openrouter",
    model: "google/gemini-3.8-flash",
    endpoint: "auto",
    tier: "priority",
    promptTokensCount: "allInput",
    maxOutputTokens: 65_536,
    prices: [
      {
        id: "reportedInputCost",
        meter: "reportedInputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      {
        id: "reportedOutputCost",
        meter: "reportedOutputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      { id: "reportedCost", meter: "reportedCost", unit: "USD", currency: "USD", amount: 1 },
    ],
  },
  {
    id: "openrouter:google/gemini-3.8-flash:google-ai-studio:default",
    billedBy: "openrouter",
    model: "google/gemini-3.8-flash",
    endpoint: "google-ai-studio",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 65_536,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.75,
      },
      {
        id: "uncachedAudioInput",
        meter: "uncachedAudioInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.75,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.075,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 3.75 },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.041667,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 14,
      },
    ],
  },
  {
    id: "openrouter:google/gemini-3.8-flash:google-ai-studio/flex:flex",
    billedBy: "openrouter",
    model: "google/gemini-3.8-flash",
    endpoint: "google-ai-studio/flex",
    tier: "flex",
    promptTokensCount: "allInput",
    maxOutputTokens: 65_536,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.375,
      },
      {
        id: "uncachedAudioInput",
        meter: "uncachedAudioInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.375,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.0375,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 1.875 },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.020833,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 14,
      },
    ],
  },
  {
    id: "openrouter:google/gemini-3.8-flash:google-ai-studio/priority:priority",
    billedBy: "openrouter",
    model: "google/gemini-3.8-flash",
    endpoint: "google-ai-studio/priority",
    tier: "priority",
    promptTokensCount: "allInput",
    maxOutputTokens: 65_536,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.35,
      },
      {
        id: "uncachedAudioInput",
        meter: "uncachedAudioInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.35,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.135,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 6.75 },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.075,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 14,
      },
    ],
  },
  {
    id: "openrouter:google/gemini-3.8-flash:google-vertex/global:default",
    billedBy: "openrouter",
    model: "google/gemini-3.8-flash",
    endpoint: "google-vertex/global",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 65_536,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.75,
      },
      {
        id: "uncachedAudioInput",
        meter: "uncachedAudioInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.75,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.075,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 3.75 },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.041667,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 14,
      },
    ],
  },
  {
    id: "openrouter:google/gemini-3.8-flash:google-vertex/global/flex:flex",
    billedBy: "openrouter",
    model: "google/gemini-3.8-flash",
    endpoint: "google-vertex/global/flex",
    tier: "flex",
    promptTokensCount: "allInput",
    maxOutputTokens: 65_536,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.375,
      },
      {
        id: "uncachedAudioInput",
        meter: "uncachedAudioInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.375,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.0375,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 1.875 },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.020833,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 14,
      },
    ],
  },
  {
    id: "openrouter:google/gemini-3.8-flash:google-vertex/global/priority:priority",
    billedBy: "openrouter",
    model: "google/gemini-3.8-flash",
    endpoint: "google-vertex/global/priority",
    tier: "priority",
    promptTokensCount: "allInput",
    maxOutputTokens: 65_536,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.35,
      },
      {
        id: "uncachedAudioInput",
        meter: "uncachedAudioInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.35,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.135,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 6.75 },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.075,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 14,
      },
    ],
  },
  {
    id: "openrouter:google/gemini-3.8-flash:google-vertex/us:default",
    billedBy: "openrouter",
    model: "google/gemini-3.8-flash",
    endpoint: "google-vertex/us",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 65_536,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.825,
      },
      {
        id: "uncachedAudioInput",
        meter: "uncachedAudioInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.825,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.0825,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 4.125 },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.041667,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 14,
      },
    ],
  },
  {
    id: "openrouter:openai/gpt-6-luna:auto:default",
    billedBy: "openrouter",
    model: "openai/gpt-6-luna",
    endpoint: "auto",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "reportedInputCost",
        meter: "reportedInputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      {
        id: "reportedOutputCost",
        meter: "reportedOutputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      { id: "reportedCost", meter: "reportedCost", unit: "USD", currency: "USD", amount: 1 },
    ],
  },
  {
    id: "openrouter:openai/gpt-6-luna:auto:priority",
    billedBy: "openrouter",
    model: "openai/gpt-6-luna",
    endpoint: "auto",
    tier: "priority",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "reportedInputCost",
        meter: "reportedInputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      {
        id: "reportedOutputCost",
        meter: "reportedOutputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      { id: "reportedCost", meter: "reportedCost", unit: "USD", currency: "USD", amount: 1 },
    ],
  },
  {
    id: "openrouter:openai/gpt-6-luna:auto:flex",
    billedBy: "openrouter",
    model: "openai/gpt-6-luna",
    endpoint: "auto",
    tier: "flex",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "reportedInputCost",
        meter: "reportedInputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      {
        id: "reportedOutputCost",
        meter: "reportedOutputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      { id: "reportedCost", meter: "reportedCost", unit: "USD", currency: "USD", amount: 1 },
    ],
  },
  {
    id: "openrouter:openai/gpt-6-luna:amazon-bedrock/us-east-1:default",
    billedBy: "openrouter",
    model: "openai/gpt-6-luna",
    endpoint: "amazon-bedrock/us-east-1",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.11,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.011,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 0.55 },
      {
        id: "cacheWrite30m",
        meter: "cacheWrite30m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.1375,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:openai/gpt-6-luna:azure:default",
    billedBy: "openrouter",
    model: "openai/gpt-6-luna",
    endpoint: "azure",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.1,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.01,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 0.5 },
      {
        id: "cacheWrite30m",
        meter: "cacheWrite30m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.125,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:openai/gpt-6-luna:azure/eu:default",
    billedBy: "openrouter",
    model: "openai/gpt-6-luna",
    endpoint: "azure/eu",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.11,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.011,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 0.55 },
      {
        id: "cacheWrite30m",
        meter: "cacheWrite30m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.1375,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:openai/gpt-6-luna:azure/us:default",
    billedBy: "openrouter",
    model: "openai/gpt-6-luna",
    endpoint: "azure/us",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.11,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.011,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 0.55 },
      {
        id: "cacheWrite30m",
        meter: "cacheWrite30m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.1375,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:openai/gpt-6-luna:openai:default",
    billedBy: "openrouter",
    model: "openai/gpt-6-luna",
    endpoint: "openai",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.1,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.01,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 0.5 },
      {
        id: "cacheWrite30m",
        meter: "cacheWrite30m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.125,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:openai/gpt-6-luna:openai/fast:priority",
    billedBy: "openrouter",
    model: "openai/gpt-6-luna",
    endpoint: "openai/fast",
    tier: "priority",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.2,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.02,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 1 },
      {
        id: "cacheWrite30m",
        meter: "cacheWrite30m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.25,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:openai/gpt-6-luna:openai/flex:flex",
    billedBy: "openrouter",
    model: "openai/gpt-6-luna",
    endpoint: "openai/flex",
    tier: "flex",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.05,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.005,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 0.25 },
      {
        id: "cacheWrite30m",
        meter: "cacheWrite30m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.0625,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:openai/gpt-6.1-sol:auto:default",
    billedBy: "openrouter",
    model: "openai/gpt-6.1-sol",
    endpoint: "auto",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "reportedInputCost",
        meter: "reportedInputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      {
        id: "reportedOutputCost",
        meter: "reportedOutputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      { id: "reportedCost", meter: "reportedCost", unit: "USD", currency: "USD", amount: 1 },
    ],
  },
  {
    id: "openrouter:openai/gpt-6.1-sol:auto:priority",
    billedBy: "openrouter",
    model: "openai/gpt-6.1-sol",
    endpoint: "auto",
    tier: "priority",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "reportedInputCost",
        meter: "reportedInputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      {
        id: "reportedOutputCost",
        meter: "reportedOutputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      { id: "reportedCost", meter: "reportedCost", unit: "USD", currency: "USD", amount: 1 },
    ],
  },
  {
    id: "openrouter:openai/gpt-6.1-sol:auto:flex",
    billedBy: "openrouter",
    model: "openai/gpt-6.1-sol",
    endpoint: "auto",
    tier: "flex",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "reportedInputCost",
        meter: "reportedInputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      {
        id: "reportedOutputCost",
        meter: "reportedOutputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      { id: "reportedCost", meter: "reportedCost", unit: "USD", currency: "USD", amount: 1 },
    ],
  },
  {
    id: "openrouter:openai/gpt-6.1-sol:auto:ultrafast",
    billedBy: "openrouter",
    model: "openai/gpt-6.1-sol",
    endpoint: "auto",
    tier: "ultrafast",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "reportedInputCost",
        meter: "reportedInputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      {
        id: "reportedOutputCost",
        meter: "reportedOutputCost",
        unit: "USD",
        currency: "USD",
        amount: 1,
      },
      { id: "reportedCost", meter: "reportedCost", unit: "USD", currency: "USD", amount: 1 },
    ],
  },
  {
    id: "openrouter:openai/gpt-6.1-sol:amazon-bedrock/us-east-1:default",
    billedBy: "openrouter",
    model: "openai/gpt-6.1-sol",
    endpoint: "amazon-bedrock/us-east-1",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.2,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.11,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 11 },
      {
        id: "cacheWrite30m",
        meter: "cacheWrite30m",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.75,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:openai/gpt-6.1-sol:azure:default",
    billedBy: "openrouter",
    model: "openai/gpt-6.1-sol",
    endpoint: "azure",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 2,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.1,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 10 },
      {
        id: "cacheWrite30m",
        meter: "cacheWrite30m",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.5,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:openai/gpt-6.1-sol:azure/eu:default",
    billedBy: "openrouter",
    model: "openai/gpt-6.1-sol",
    endpoint: "azure/eu",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.2,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.11,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 11 },
      {
        id: "cacheWrite30m",
        meter: "cacheWrite30m",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.75,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:openai/gpt-6.1-sol:azure/us:default",
    billedBy: "openrouter",
    model: "openai/gpt-6.1-sol",
    endpoint: "azure/us",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.2,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.11,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 11 },
      {
        id: "cacheWrite30m",
        meter: "cacheWrite30m",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.75,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:openai/gpt-6.1-sol:openai:default",
    billedBy: "openrouter",
    model: "openai/gpt-6.1-sol",
    endpoint: "openai",
    tier: "default",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 2,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.1,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 10 },
      {
        id: "cacheWrite30m",
        meter: "cacheWrite30m",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.5,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:openai/gpt-6.1-sol:openai/fast:priority",
    billedBy: "openrouter",
    model: "openai/gpt-6.1-sol",
    endpoint: "openai/fast",
    tier: "priority",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 4,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.2,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 20 },
      {
        id: "cacheWrite30m",
        meter: "cacheWrite30m",
        unit: "1M tokens",
        currency: "USD",
        amount: 5,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:openai/gpt-6.1-sol:openai/flex:flex",
    billedBy: "openrouter",
    model: "openai/gpt-6.1-sol",
    endpoint: "openai/flex",
    tier: "flex",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 1,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.05,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 5 },
      {
        id: "cacheWrite30m",
        meter: "cacheWrite30m",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.25,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
  {
    id: "openrouter:openai/gpt-6.1-sol:openai/ultrafast:ultrafast",
    billedBy: "openrouter",
    model: "openai/gpt-6.1-sol",
    endpoint: "openai/ultrafast",
    tier: "ultrafast",
    promptTokensCount: "allInput",
    maxOutputTokens: 128_000,
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 12,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.6,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 60 },
      {
        id: "cacheWrite30m",
        meter: "cacheWrite30m",
        unit: "1M tokens",
        currency: "USD",
        amount: 15,
      },
      {
        id: "tool:web_search",
        meter: "tool:web_search",
        unit: "1k uses",
        currency: "USD",
        amount: 10,
      },
    ],
  },
];
